import { render } from "./InviteAthlete.vue?vue&type=template&id=9ee52ffc"
import script from "./InviteAthlete.vue?vue&type=script&lang=js"
export * from "./InviteAthlete.vue?vue&type=script&lang=js"
script.render = render

export default script